import React from 'react'
import { Linking, ScrollView, Text, TouchableOpacity, View } from 'react-native'
import { LogoDark } from '../../../assets/icons'
import { Spacer } from '../../../ui/atoms'
import { useResponsive } from '../../../utils/hooks'
import { useTranslation } from 'react-i18next'
import { styles } from './styles'
import { LogoContainer } from './LogoContainer'
import { LayoutProps } from '.'
import { CoBrandingHeader } from '../../../ui/white-label-components/Header'
import { urls } from '@linqpal/models/src/dictionaries'
import { composeStyle } from '@linqpal/common-frontend/src/helpers'

const Footer = () => {
  const { t } = useTranslation('auth')
  return (
    <View
      style={{ alignItems: 'center', justifyContent: 'flex-start' }}
      testID="poweredByBluetape"
    >
      <Text
        style={{
          fontFamily: 'Inter, sans-serif',
          fontWeight: '400',
          fontSize: 16,
          lineHeight: 19,
          color: '#003353',
        }}
      >
        {t('poweredBy')}
      </Text>
      <Spacer height={10} />
      <TouchableOpacity onPress={() => Linking.openURL(urls.BT)}>
        <LogoDark width={167} />
      </TouchableOpacity>
      <Spacer height={60} />
    </View>
  )
}

export const WhiteLabelLayout = ({
  showsBackButton,
  onBackPress,
  children,
  contentWidth,
  contentStyle,
}: LayoutProps) => {
  const { sm } = useResponsive()
  return (
    <View style={styles.layoutRootView}>
      {sm ? (
        <LogoContainer
          showsBackButton={showsBackButton}
          onBackPress={onBackPress}
        />
      ) : (
        <CoBrandingHeader />
      )}
      <ScrollView
        contentContainerStyle={composeStyle(
          {
            marginTop: sm ? 40 : 28,
            flexGrow: 1,
          },
          contentStyle,
        )}
      >
        <View style={{ width: contentWidth, alignSelf: 'center', flexGrow: 1 }}>
          {children}
        </View>
        <Spacer height={sm ? 40 : 28} />
        {sm && <Footer />}
      </ScrollView>
    </View>
  )
}
